import React, { useEffect } from "react";
import { useState } from "react";
import { ReactComponent as UpperArrow } from "assets/images/icons/upper-arrow.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import { ReactComponent as CreditCardIcon } from "assets/images/icons/credit-card.svg";
import { config as globalConfig } from "../../../../../../../config";
import * as globalUtils from "../../../../../../../helpers/utils";
import { Button } from "primereact/button";
import StyleWrapper from "../style";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { getMileagePerYear, getParkingLocations } from "services/motorRetailService";
import i18n from "translations";
import { useDispatch, useSelector } from "react-redux";
import { updateFormsStatus, updateFormsValue } from "redux/actions/motorActions";
import { useTranslation } from "react-i18next";
import config from "application/motor/helpers/config";


const OtherVehicleInfo = (props) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const {applicationDetailsForms, applicationDetailsStatus} = useSelector((state) => state.motor);
  const [millageList, setMillageList] = useState([

  ]);
  const [parkingLocationsList, setParkingLocationsList] = useState([]);

  const formik = useFormik({
    initialValues: {
      mileageExpectedYearly: props.defaultValues?.mileagePerYear?.code ||"2",
      transmission: props.defaultValues?.transmission?.code || "1",
      parkingLocation: props.defaultValues?.parkingLocation?.code || 'MOTOR_AR_ONROAD',
      street:'0000'
    },
    validate: (data) => {
      let errors = {};
      if (!data.mileageExpectedYearly) {
        errors.mileageExpectedYearly = "Required";
      }
      if (!data.transmission) {
        errors.transmission = "Required";
      }
      if (!data.parkingLocation) {
        errors.parkingLocation = "Required";
      }
      return errors;
    },

    onSubmit: (data) => {
      ////     // console.log(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };



  useEffect(() => {
    if (props.submitForm) {
      formik.submitForm();
      const data = {...applicationDetailsForms};
      const valid = applicationDetailsStatus;
      dispatch(updateFormsValue({...data, OtherVehicleInfo: {...formik.values}}));
      dispatch(updateFormsStatus(valid? valid&&formik.isValid : formik.isValid));
    }
  }, [props.submitForm, formik.isValid]);

  return (
    <StyleWrapper businessColor={props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT}>
      <div className={"info-card form_card " + props.className + `${i18n.language ==='ar'? ' ar' : ''}`}>
        <div className="header">
          <h5>{t("MotorEn.OtherInformation")}</h5>
        </div>
        <Divider />
        <form onSubmit={formik.handleSubmit} className="mt-4">
          <div className="row">
            <div className="col-md-6 col-12 mb-4">
              <div className="field mt-2">
                <span className="p-float-label">
                  <Dropdown
                    inputId="mileageExpectedYearly"
                    name="mileageExpectedYearly"
                    value={formik.values.mileageExpectedYearly}
                    className={classNames({
                      "p-invalid": isFormFieldValid("mileageExpectedYearly"),
                      "fm-tawuniya": true
                    })}
                    onChange={formik.handleChange}
                    options={i18n.language === 'ar'? config.MileagePerYearAR : config.MileagePerYear}
                    optionLabel="mileagePerYearDescription"
                    optionValue="mileagePerYearCode"
                  />
                  <label htmlFor="idType">{t("MotorEn.MileageExpected")}</label>
                </span>
                {getFormErrorMessage("idType")}
              </div>
            </div>
            <div className="col-md-6 col-12 mb-4">
              <div className="field mt-2">
                <label className="mb-1">{t("MotorEn.Transmission")}</label>
                <div className="d-flex gap-3">
                  <div className="radio_wrapper">
                    <RadioButton
                      name="transmission"
                      value="1"
                      id="automatic"
                      onChange={formik.handleChange}
                      checked={formik.values.transmission == "1"}
                    />{" "}
                    <label htmlFor="automatic"> {t("MotorEn.Automatic")} </label>
                  </div>
                  <div className="radio_wrapper">
                    <RadioButton
                      name="transmission"
                      value="2"
                      id="automatic"
                      onChange={formik.handleChange}
                      checked={formik.values.transmission == "2"}
                    />{" "}
                    <label htmlFor="manual"> {t("MotorEn.Manual")} </label>
                  </div>
                </div>
                {getFormErrorMessage("city")}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-12 mb-4">
              <div className="field mt-2">
                <span className="p-float-label">
                  <Dropdown
                    inputId="parkingLocation"
                    name="parkingLocation"
                    value={formik.values.parkingLocation}
                    className={classNames({
                      "p-invalid": isFormFieldValid("parkingLocation"),
                    })}
                    onChange={formik.handleChange}
                    options={i18n.language === 'ar'? config.ParkingLocationsAr : config.ParkingLocations}
                    optionLabel="locationDescription"
                    optionValue="locationCode"
                  />
                  <label htmlFor="parkingLocation">{t("MotorEn.ParkingLocation")}</label>
                </span>
                {getFormErrorMessage("parkingLocation")}
              </div>
            </div>

            <div className="col-md-6 col-12 mb-4">
              <div className="field mt-2">
                <span className="p-float-label">
                  <InputText
                    value={formik.values.street}
                    name="street"
                    id="street"
                    onChange={formik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid("street"),
                      "fm-tawuniya":  /[0-9]/.test(formik.values.street)
                    })}
                    placeholder=""
                  />
                  <label htmlFor="street">{t("MotorEn.Street")} </label>
                </span>
                {getFormErrorMessage("street")}
              </div>
            </div>
          </div>
        </form>
      </div>
    </StyleWrapper>
  );
};

export default OtherVehicleInfo;
